export default {
    SET_LOADING: "SET-LOADING",
    SET_TOGGLE_NAV: "SET_TOGGLE_NAV"
}